import { OpenEndQuestion, RankingQuestion } from "../../../types/Question";

// <text 
//   label="Q14"
//   optional="0"
//   size="25"
//   verify="len(0,128)">
//   <title>Short open ended</title>
//   <comment>Please be specific.</comment>
// </text>

// <textarea 
//   label="Q15"
//   height="10"
//   optional="0"
//   width="50">
//   <title>Medium Open ended</title>
//   <comment>Please be specific.</comment>
// </textarea>
/**
 * Export question as XML-precursor data type.
 *
 * @export
 * @param {RankingQuestion} question
 * @return {*}
 */
export default function toXmlType(question: OpenEndQuestion) {
  switch (question.response_length) {
    case "short":
      return {
        text: {
          _attributes: {
            label: `Q${question.id}`,
            size: `25`,
            // verify="len(0,128)">
          },
          title: question.title,
        },
      };
      default:
        return {
          textarea: {
            _attributes: {
              label: `Q${question.id}`,
              height: question.response_length == "medium" ? 10 : 20,
              // verify="len(0,128)">
            },
            title: question.title,
          },
        };
    }
}
